var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAreachart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3577 4.06618C21.7446 4.21437 22 4.58575 22 5.00001L21.9999 19C21.9999 19.5523 21.5522 20 20.9999 20H3C2.44772 20 2 19.5523 2 19V10.091C2 9.73528 2.18894 9.40636 2.49619 9.22716C2.80344 9.04796 3.18275 9.04545 3.49234 9.22057L7.38513 11.4225L11.3531 8.05573C11.6574 7.79754 12.086 7.74498 12.4437 7.922L15.6204 9.49434L20.2559 4.33188C20.5327 4.02365 20.9709 3.91798 21.3577 4.06618ZM20 7.61043L16.6012 11.3955C16.3014 11.7294 15.8158 11.8227 15.4136 11.6236L12.1457 10.0061L8.14708 13.399C7.82745 13.6702 7.37261 13.7132 7.00775 13.5069L4 11.8055V18H19.9999L20 7.61043Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreachart);
export default __webpack_public_path__ + "static/media/areachart.20f6e0556f49e0164d2112a2b9e46a80.svg";
export { ForwardRef as ReactComponent };